// extracted by mini-css-extract-plugin
export var fulfillmentPanel = "_iv-0";
export var fulfillmentPanelBody = "_iv-1";